import { c as _c } from "react/compiler-runtime";
import { TabColumnDefinitionInterface } from 'modules/funnels/funnel/components/tab-table';
import { FunnelStepStatTableInterface } from 'modules/funnels/funnel/types/funnel-tests-interface';
import { IconTile } from 'shared/components/icon-tile';
import { MobileCardHeader } from 'shared/components/table/components/mobile-card-header';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export const useSplitTestTableColumns = () => {
  const $ = _c(34);
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] !== t) {
    t0 = variation => t(variation === "original" ? "dashboard.funnel.split_tests.original_title" : "dashboard.funnel.split_tests.variant_title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getVariationTitle = t0;
  let t1;
  if ($[2] !== t) {
    t1 = t("dashboard.funnel.split_tests.variation");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== getVariationTitle) {
    t2 = [{
      widthPercent: 100,
      onRender: funnelStep => <div className="flex min-w-0 flex-col"><span className="text-text-primary truncate">{getVariationTitle(funnelStep.variation)}</span><span className="text-text-tertiary truncate text-sm">{funnelStep.funnelStepName}</span></div>,
      onRenderSmall: funnelStep_0 => {
        const isOriginal = funnelStep_0.variation === "original";
        return <MobileCardHeader icon={<IconTile tone={isOriginal ? "primary" : "lightGreen"} size="m">{isOriginal ? "A" : "B"}</IconTile>} title={getVariationTitle(funnelStep_0.variation)} subtitle={funnelStep_0.funnelStepName} />;
      }
    }];
    $[4] = getVariationTitle;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = {
      key: "funnelStepName",
      header: t1,
      widthPercent: 30,
      subHeaders: t2
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("dashboard.funnel.statistics.page_views");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [{
      widthPercent: 100,
      onRender: _temp
    }];
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4) {
    t6 = {
      key: "pageViewsUnique",
      header: t4,
      widthPercent: 30,
      subHeaders: t5
    };
    $[12] = t4;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("dashboard.funnel.split_tests.conversions");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("dashboard.funnel.statistics.all");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = {
      widthPercent: 30,
      title: t8,
      onRender: _temp2
    };
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("dashboard.funnel.statistics.conversion_rate");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10) {
    t11 = {
      widthPercent: 70,
      title: t10,
      onRender: _temp3
    };
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t9) {
    t12 = [t9, t11];
    $[24] = t11;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t7) {
    t13 = {
      key: "optIns",
      header: t7,
      widthPercent: 20,
      subHeaders: t12
    };
    $[27] = t12;
    $[28] = t7;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13 || $[31] !== t3 || $[32] !== t6) {
    t14 = [t3, t6, t13];
    $[30] = t13;
    $[31] = t3;
    $[32] = t6;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  return t14;
};
function _temp(funnelStep_1) {
  return <span className="truncate font-normal">{funnelStep_1.pageViewsUnique}</span>;
}
function _temp2(funnelStep_2) {
  return <span className="truncate font-normal">{funnelStep_2.conversionAll}</span>;
}
function _temp3(funnelStep_3) {
  return <span className="truncate font-normal">{funnelStep_3.conversionRate}</span>;
}